$('.openinghours__weeks button').click(function() {
	var id = $(this).attr('aria-controls');

	// Set the clicked button as active
	$('.openinghours__weeks button').removeClass('active');
	$(this).addClass('active');

	// Show the connected week list
	$('.openinghours__list').hide();
	$('#' + id).show();
});